import { useState, useEffect } from 'react';
import { Box, Table, TableBody, TableHead, TableRow, MenuItem } from '@mui/material';
import {
  DialogBody,
  HeadTableCell,
  RowTableCell,
  CustomButton,
  CustomSelect,
  ActionIconButton,
  GeneralTableBox,
  NoDataSkeleton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import FeeStructureDialog from '../dialogs/FeeStructureDialog';

const FeeStructuresTab = ({
  data,
  fees,
  selectedItem,
  dialogOpen,
  editMode,
  selectedPlan,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const [selectedFee, setSelectedFee] = useState(null);
  const [filteredFeeStructures, setFilteredFeeStructures] = useState([]);

  useEffect(() => {
    if (fees.length > 0 && selectedPlan) {
      const feesWithSelectedPlan = fees.filter((fee) => fee.uuid_plan === selectedPlan.uuid);
      if (feesWithSelectedPlan.length > 0) {
        setSelectedFee(feesWithSelectedPlan[0]);
        setFilteredFeeStructures(
          data.filter((feeStructure) => feeStructure.uuid_fee === feesWithSelectedPlan[0].uuid)
        );
      }
    }
  }, [fees, data, selectedPlan]);

  const handleSelectChange = (event) => {
    setSelectedFee(event.target.value);
    setFilteredFeeStructures(
      data.filter((feeStructure) => feeStructure.uuid_fee === event.target.value.uuid)
    );
  };

  useEffect(() => {
    if (selectedFee) {
      setFilteredFeeStructures(
        data.filter((feeStructure) => feeStructure.uuid_fee === selectedFee.uuid)
      );
    }
  }, [selectedFee, data]);

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="base" onClick={handleAdd} buttonIcon={PostAddIcon}>
            Agregar
          </CustomButton>
          <CustomSelect
            label={'Tipo Cuota'}
            labelId="feeType-label"
            name="feeType"
            onChange={handleSelectChange}
            value={selectedFee || ''}
            size="medium"
            sx={{ minWidth: 200, maxWidth: 300 }}
          >
            {fees
              .filter((fee) => fee.uuid_plan === selectedPlan?.uuid)
              .map((fee, index) => (
                <MenuItem key={index} value={fee}>
                  {fee.name}
                </MenuItem>
              ))}
          </CustomSelect>
        </Box>
        <GeneralTableBox>
          {filteredFeeStructures.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <HeadTableCell>Item</HeadTableCell>
                  <HeadTableCell>Monto Fijo ($)</HeadTableCell>
                  <HeadTableCell>Porcentaje (%)</HeadTableCell>
                  <HeadTableCell>Iva (%)</HeadTableCell>
                  <HeadTableCell>Acciones</HeadTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredFeeStructures.map((feeStructure, index) => (
                  <TableRow key={index}>
                    <RowTableCell>{feeStructure.name}</RowTableCell>
                    <RowTableCell>{feeStructure.fixed_amount}</RowTableCell>
                    <RowTableCell>{feeStructure.rate}</RowTableCell>
                    <RowTableCell>{feeStructure.iva}</RowTableCell>
                    <RowTableCell>
                      <ActionIconButton variant="edit" onClick={() => handleEdit(feeStructure)} />
                      <ActionIconButton
                        variant="delete"
                        onClick={() => handleDelete(feeStructure.uuid)}
                      />
                    </RowTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <NoDataSkeleton />
          )}
        </GeneralTableBox>
      </Box>

      <FeeStructureDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={(data) => handleSave({ ...data, uuid_fee: selectedFee?.uuid })}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default FeeStructuresTab;
